import { axiosInstance } from './client';

export interface DownloadOptions {
  method?: 'GET' | 'POST';
  data?: unknown;
  filename: string;
  fallbackMime?: string;
}

export async function downloader(url: string, opts: DownloadOptions): Promise<void> {
  const res = await axiosInstance({
    url,
    method: opts.method ?? 'GET',
    data: opts.data,
    responseType: 'blob',
  });
  const headerMime = res.headers && (res.headers['content-type'] as string | undefined);
  const mime = headerMime || opts.fallbackMime || 'application/pdf';
  const blob = new Blob([res.data as BlobPart], { type: mime });
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = opts.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
